/* eslint-disable no-plusplus */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
import React, { useEffect, useState } from "react";
import { BsFillEyeSlashFill } from "react-icons/bs";
import { IoEyeSharp } from "react-icons/io5";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  TextField,
  Select,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import { CheckBox } from "components/checkBoxCommon/styles";
import ModalCommon from "components/ModalCommon";
import { RiAddLine } from "react-icons/ri";
import { BiSolidTrashAlt } from "react-icons/bi";
import { MdEdit, MdCheckBoxOutlineBlank } from "react-icons/md";
import {
  differenceInMonths,
  endOfMonth,
  getMonth,
  getYear,
  isBefore,
  parse,
  parseISO,
  startOfMonth,
  subDays,
} from "date-fns";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useEditarItem } from "services/api/AppWeb_PropostaVendas/editar-item";

import { useResetarFluxo } from "services/api/AppWeb_PropostaVendas/resetar-fluxo";

import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { CARGO_CODES } from "constants/permissions";

import { useZerarPV } from "services/api/AppWeb_PropostaVendas/zerar-pv";
import { useInserirDesconto } from "services/api/AppWeb_PropostaVendas/inserir-desconto";
import { useExcluirSeries } from "services/api/AppWeb_PropostaVendas/excluir-series";
import { IoMdCheckbox } from "react-icons/io";
import { useLocation, useParams } from "react-router-dom";
import { useEditarProposta } from "services/api/AppWeb_PropostaVendas/editar-proposta";
import { toast } from "react-toastify";
import * as Styles from "./styles";
import ResetarFluxoModal from "../components/ResetarFluxoModal";
import ExcluirModal from "../components/ExcluirModal";
import DescontoModal from "../components/DescontoModal";
import ZerarPVModal from "../components/ZerarPVModal";
import AdicionarItemModal from "../components/AdicionarItemModal";
import EditarItemModal from "../components/EditarItemModal";
import MaterialUI from "../../../../../../../material-UI";
import VoltarFluxoModal from "../components/VoltarFluxoModal";
import { GlobalStyles } from "./styles";

interface Props {
  dataDetalheProposta: any;
  dataDetalheOportunidade?: any;
  onClose: () => void;
  refetchProposta: () => void;
  idLead: string | undefined;
  isRefetching: boolean;
}

const TipoSerieEnum = {
  "100000000": "Sinal",
  "100000005": "Inicial",
  "100000001": "Parcelas",
  "100000002": "Unica",
  "100000003": "Financiamento",
  "100000012": "Alienação Fiduciária",
  "100000004": "Credito Associativo",
  "100000013": "Comissão",
  "100000014": "Dação",
  "100000015": "Migração",
  "100000016": "Bônus",
};

const FrequenciaEnum = {
  "100000000": "Mensal",
  "100000001": "Bimestral",
  "100000002": "Trimestral",
  "100000003": "Quadrimestral",
  "100000004": "Semestral",
  "100000005": "Unica",
  "100000006": "Anual",
};

const ProductCard: React.FC<Props> = (props) => {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const isGerenteComercial = codigoCargo2013 === CARGO_CODES.GERENTE_COMERCIAL;
  const [ocultar, setOcultar] = React.useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [isExcluirModalOpen, setIsExcluirModalOpen] = useState(false);
  const [isDescontoModalOpen, setIsDescontoModalOpen] = useState(false);
  const [isZerarPVModalOpen, setIsZerarPVModalOpen] = useState(false);
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [isEditItemModalOpen, setIsEditItemModalOpen] = useState(false);
  // const [isNovaOportunidadeModalOpen, setIsNovaOportunidadeModalOpen] =
  //   useState(false);
  const [isVoltarFluxoModalOpen, setIsVoltarFluxoModalOpen] = useState(false);
  const [desconto, setDesconto] = useState("");
  const params: any = useParams();
  const location = useLocation();
  const paramsLocation = new URLSearchParams(location.search);
  const [rows, setRows] = useState([
    {
      idSerie: "",
      tipoSerie: "",
      qtdParcelas: "",
      frequencia: "",
      valorParcela: "",
      valorPercent: "",
      valorTP: "",
      valorVp: "",
      juros: false,
      fixo: false,
      valorTotal: "",
      dataVencimento: "",
    },
  ]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [numeroCotacao, setNumeroCotacao] = useState<string>("");

  // Estados para edição inline
  const [editingRow, setEditingRow] = useState<string | null>(null);
  const [editingField, setEditingField] = useState<string | null>(null);
  const [editValue, setEditValue] = useState<any>(null);
  const [editingDate, setEditingDate] = useState<Date | null>(null);
  const [editingRowData, setEditingRowData] = useState<any>(null);
  const [qtdsParcelasList, setQtdsParcelasList] = useState<any[]>([]);
  const [isTableLoading, setIsTableLoading] = useState(false);

  // Estados para edição do tipoSerie
  const [tipoSerieList, setTipoSerieList] = useState<any[]>([]);
  const tipoSerieArray = Object.entries(TipoSerieEnum).map(
    ([value, label]) => ({ label, value })
  );

  // Lista de campos que podem ser editados
  const editableFields = [
    "tipoSerie",
    "qtdParcelas",
    "frequencia",
    "valorParcela",
    "dataVencimento",
    "juros",
    "fixo",
  ];

  // Dias permitidos para vencimento
  const diasPermitidos = [10, 15, 20, 25];

  // Tipos de série com configurações fixas
  const tiposValidos = [
    "100000000",
    "100000002",
    "100000003",
    "100000004",
    "100000005",
    "100000012",
  ];

  // Função utilitária para verificar se é do tipo Sinal
  const isTipoSinal = (row: any): boolean => {
    const tipoSerieValue =
      typeof row.tipoSerie === "string"
        ? row.tipoSerie
        : row.tipoSerie.toString();
    return tipoSerieValue === "100000000";
  };

  // Função utilitária para verificar se o tipo tem data de vencimento fixa
  const isTipoDataVencimentoFixa = (row: any): boolean => {
    const tipoSerieValue =
      typeof row.tipoSerie === "string"
        ? row.tipoSerie
        : row.tipoSerie.toString();
    return tipoSerieValue === "100000000" || tipoSerieValue === "100000002"; // Sinal ou Unica
  };

  const validarDiaPermitido = (date: Date) => {
    // Retorna true se o dia do mês está entre os dias permitidos
    return diasPermitidos.includes(date.getDate());
  };

  // Hook de edição
  const editItemMutation = useEditarItem({
    idUnidade: editingRowData?.idUnidade || "",
    idSerie: editingRowData?.idSerie || "",
    tipoSerie: editingRowData?.tipoSerie || "",
    qtdParcelas: editingRowData?.qtdParcelas || "",
    frequencia: editingRowData?.frequencia || "",
    valorParcela: editingRowData?.valorParcela || "",
    dtVencimento: editingRowData?.dtVencimento || new Date(),
    juros: editingRowData?.juros || false,
    fixo: editingRowData?.fixo || false,
    idLeadCorretor: params.idLeadCorretor || "",
    idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
  });

  useEffect(() => {
    if (editItemMutation.isSuccess) {
      Promise.resolve(props.refetchProposta()).finally(() => {
        cancelEditing();
      });
    }
  }, [editItemMutation.isSuccess]);

  useEffect(() => {
    if (editItemMutation.isError) {
      toast.error("Erro ao editar item. Tente novamente.");
      cancelEditing();
    }
  }, [editItemMutation.isError]);

  // Verificar se a proposta é editável
  const isEditable = () => {
    return props?.dataDetalheProposta?.editavel;
  };

  // Função para iniciar a edição de um campo
  const startEditing = (rowId: string, field: string, value: any, row: any) => {
    // Verifica se a proposta é editável
    if (!isEditable()) {
      return;
    }

    if (!editableFields.includes(field)) return;

    // Para tipos com data de vencimento fixa, impede a edição de data de vencimento, quantidade de parcelas e frequência
    if (
      isTipoDataVencimentoFixa(row) &&
      (field === "dataVencimento" ||
        field === "qtdParcelas" ||
        field === "frequencia")
    ) {
      const tipoSerie = row.tipoSerie.toString();
      const tipoNome = tipoSerie === "100000000" ? "Sinal" : "Unica";
      toast.info(`Não é possível editar este campo para o tipo ${tipoNome}`);
      return;
    }

    setEditingRow(rowId);
    setEditingField(field);
    setEditingRowData(row);

    if (field === "dataVencimento") {
      setEditingDate(parseISO(value));
    } else if (field === "qtdParcelas") {
      // Gera as opções de parcelas com base na série e frequência
      gerarOpcoesQtdParcelas(row);
      setEditValue(value.toString());
    } else if (field === "valorParcela") {
      // Formatar o valor para o padrão brasileiro quando iniciar edição
      const formattedValue = parseFloat(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      });
      setEditValue(formattedValue);
    } else {
      setEditValue(value.toString());
    }
  };

  // Função para cancelar a edição
  const cancelEditing = () => {
    setEditingRow(null);
    setEditingField(null);
    setEditValue(null);
    setEditingDate(null);
    setEditingRowData(null);
  };

  // Formatação e conversão
  const formatCurrencyString = (value: string) => {
    const cleanedValue = value.replace(/[^\d.]/g, "");
    const numberValue = parseFloat(cleanedValue);
    const formattedValue = numberValue.toFixed(2).replace(".", ",");
    return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const convertToNumber = (brNumber: string): number => {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  };

  const handleValorParcelaChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value.replace(/[^\d]/g, "");
    const numericValue = parseInt(value, 10) / 100;
    setEditValue(formatCurrencyString(numericValue.toString()));
  };

  // Gerando opções para os campos de seleção
  const gerarOpcoesQtdParcelas = (row: any) => {
    // Normalizar o tipoSerie e frequencia para string para comparações consistentes
    const tipoSerie =
      typeof row.tipoSerie === "string"
        ? row.tipoSerie
        : row.tipoSerie.toString();

    const frequencia =
      typeof row.frequencia === "string"
        ? row.frequencia
        : row.frequencia.toString();

    // Gerar dropdown baseado no tipo de série e frequência
    if (tiposValidos.includes(tipoSerie) || frequencia === "100000005") {
      setQtdsParcelasList([{ value: "1", label: "1" }]);
      return;
    }

    if (tipoSerie === "100000001") {
      // Parcelas
      const dataJuros = props?.dataDetalheProposta?.serie?.dataJuros;
      if (dataJuros) {
        // Usar a data de vencimento da linha para calcular o número de parcelas
        const dataVencimento = parseISO(row.dataVencimento);
        const vencimento = startOfMonth(dataVencimento);
        const entrega = startOfMonth(new Date(dataJuros));

        // Verificar se a data de vencimento é posterior à data de juros
        if (vencimento > entrega) {
          // Se a data de vencimento é posterior à data de juros,
          // o usuário pode escolher qualquer quantidade de parcelas
          const parcelasArray = [];
          for (let i = 1; i <= 360; i++) {
            parcelasArray.push({
              label: `${i}`,
              value: `${i}`,
            });
          }
          setQtdsParcelasList(parcelasArray);
          return;
        }

        // Se a data de vencimento é anterior ou igual à data de juros,
        // calcular baseado na diferença de meses
        let totalMeses = differenceInMonths(entrega, vencimento);
        if (entrega >= vencimento) {
          totalMeses += 1;
        }

        const numeroParcelas = totalMeses > 0 ? totalMeses : 1;
        let maxParcelas = numeroParcelas;

        switch (frequencia) {
          case "100000000": // Mensal
            maxParcelas = numeroParcelas;
            break;
          case "100000001": // Bimestral
            maxParcelas = Math.ceil(numeroParcelas / 2);
            break;
          case "100000002": // Trimestral
            maxParcelas = Math.ceil(numeroParcelas / 3);
            break;
          case "100000003": // Quadrimestral
            maxParcelas = Math.ceil(numeroParcelas / 4);
            break;
          case "100000004": // Semestral
            maxParcelas = Math.ceil(numeroParcelas / 6);
            break;
          case "100000006": // Anual
            maxParcelas = Math.ceil(numeroParcelas / 12);
            break;
          default:
            maxParcelas = 360;
        }

        const parcelasArray = [];
        for (let i = 1; i <= maxParcelas; i++) {
          parcelasArray.push({
            label: `${i}`,
            value: `${i}`,
          });
        }
        setQtdsParcelasList(parcelasArray);
      } else {
        // Sem data de juros definida, oferecemos opções padrão
        const parcelasArray = [];
        for (let i = 1; i <= 360; i++) {
          parcelasArray.push({
            label: `${i}`,
            value: `${i}`,
          });
        }
        setQtdsParcelasList(parcelasArray);
      }
    } else {
      // Outros tipos de série com ampla gama de opções
      const parcelasArray = [];
      for (let i = 1; i <= 360; i++) {
        parcelasArray.push({
          label: `${i}`,
          value: `${i}`,
        });
      }
      setQtdsParcelasList(parcelasArray);
    }
  };

  const openAddItemModal = () => setIsAddItemModalOpen(true);
  const closeAddItemModal = () => setIsAddItemModalOpen(false);
  const openEditItemModal = () => setIsEditItemModalOpen(true);
  const closeEditItemModal = () => setIsEditItemModalOpen(false);
  const openZerarPVModal = () => setIsZerarPVModalOpen(true);
  const closeZerarPVModal = () => setIsZerarPVModalOpen(false);
  const openDescontoModal = () => setIsDescontoModalOpen(true);
  const closeDescontoModal = () => setIsDescontoModalOpen(false);
  const openExcluirModal = () => setIsExcluirModalOpen(true);
  const closeExcluirModal = () => setIsExcluirModalOpen(false);
  // const openNovaOportunidadeModal = () => setIsNovaOportunidadeModalOpen(true);
  // const closeNovaOportunidadeModal = () =>
  //   setIsNovaOportunidadeModalOpen(false);
  const openVoltarFLuxoModal = () => setIsVoltarFluxoModalOpen(true);
  const closeVoltarFluxoModal = () => setIsVoltarFluxoModalOpen(false);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    const arrayData: any = [];
    props?.dataDetalheProposta?.serie?.serieTabela?.map((item: any) =>
      arrayData.push({
        idSerie: item?.idSerie,
        tipoSerie: item?.tipoSerie,
        qtdParcelas: item?.qtdParcelas,
        frequencia: item?.frequencia,
        valorParcela: item?.valorParcela,
        valorPercent: item?.valorPercent,
        valorTP: item?.valorTP,
        valorVp: item?.valorVp,
        juros: item?.juros,
        fixo: item?.fixo,
        valorTotal: item?.valorTotal,
        dataVencimento: item?.dataVencimento,
      })
    );
    setRows(arrayData);
  }, [props?.dataDetalheProposta?.serie?.serieTabela]);

  useEffect(() => {
    setOcultar(true);
  }, [
    props?.dataDetalheOportunidade?.idOportunidade,
    props?.dataDetalheProposta?.numeroCotacao,
  ]);

  const disableButtonEdit = () => {
    if (selectedRows.length === 1) return false;
    return true;
  };

  const disableButton = () => {
    if (selectedRows.length === 0) return true;
    return false;
  };

  const disableButtonDelete = () => {
    return selectedRows.length === 0;
  };
  const handleSelectRow = (obj: any) => {
    if (selectedRows.some((i: any) => i.idSerie === obj.idSerie)) {
      setSelectedRows(
        selectedRows.filter((i: any) => i.idSerie !== obj.idSerie)
      );
    } else {
      setSelectedRows([...selectedRows, obj]);
    }
  };

  function padToTwoDigits(num: number): string {
    return num.toString().padStart(2, "0");
  }
  function formatarDataISO(dataISO: string): string {
    if (!dataISO) {
      return "--";
    }

    try {
      const partes = dataISO.split("-");
      if (partes.length === 3) {
        const ano = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1;
        const dia = parseInt(partes[2], 10);

        const dataObj = new Date(ano, mes, dia);

        const diaFormatado = padToTwoDigits(dataObj.getDate());
        const mesFormatado = padToTwoDigits(dataObj.getMonth() + 1);
        const anoFormatado = dataObj.getFullYear();
        const dataFormatada = `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
        return dataFormatada;
      }
      throw new Error("Formato de data inválido");
    } catch (error) {
      console.error("Erro ao formatar a data:", error);
      return "--";
    }
  }

  const filterIdsSerieSelectedRows = () => {
    if (selectedRows.length === 0) return [];
    return selectedRows.map((item: any) => item.idSerie);
  };

  const {
    mutate: mutate1,
    reset: reset1,
    isSuccess: isSuccess1,
    isLoading: isLoading1,
  } = useResetarFluxo({
    idUnidade: props?.dataDetalheProposta?.idUnidade,
    idLeadCorretor: params.idLeadCorretor,
  });

  const {
    mutate: mutate2,
    reset: reset2,
    isSuccess: isSuccess2,
    isLoading: isLoading2,
  } = useZerarPV({
    idUnidade: props?.dataDetalheProposta?.idUnidade,
    idsSerie: filterIdsSerieSelectedRows() as string[],
    idLeadCorretor: params.idLeadCorretor,
    idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
  });

  const {
    mutate: mutate3,
    reset: reset3,
    isSuccess: isSuccess3,
    isLoading: isLoading3,
  } = useInserirDesconto({
    idUnidade: props?.dataDetalheProposta?.idUnidade,
    idsSerie: filterIdsSerieSelectedRows() as string[],
    porcentagemDesconto: desconto,
    idLeadCorretor: params.idLeadCorretor,
    idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
  });

  const {
    mutate: mutate4,
    reset: reset4,
    isSuccess: isSuccess4,
    isLoading: isLoading4,
  } = useExcluirSeries({
    idUnidade: props?.dataDetalheProposta?.idUnidade,
    idsSerie: filterIdsSerieSelectedRows() as string[],
    idLeadCorretor: params.idLeadCorretor,
    idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
  });

  const {
    mutate: mutate5,
    isSuccess: isSuccess5,
    isLoading: isLoading5,
    data: data5,
    reset: reset5,
  } = useEditarProposta({
    idUnidade: props?.dataDetalheProposta?.idUnidade,
    idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
    idLead: props?.idLead,
  });

  useEffect(() => {
    setSelectedRows([]);
  }, [isSuccess1, isSuccess2, isSuccess3, isSuccess4]);

  useEffect(() => {
    if (isSuccess5) {
      // openNovaOportunidadeModal();
      // setNumeroCotacao(data5?.data?.numeroCotacao);
      // window.location.href = `${params?.idLeadCorretor}/opportunity-detail/${data5?.data?.numeroCotacao}`;
      props.onClose();
      reset5();
    }
  }, [isSuccess5]);

  const handleNovaOportunidade = () => {
    if (
      !props?.dataDetalheProposta?.serie?.serieTabela?.some(
        (item: any) => item.tipoSerie === 100000000
      )
    ) {
      toast.error(
        "Proposta não contém série de sinal, refaça a simulação incluindo essa série"
      );
      return;
    }

    // Verificar se há datas de vencimento incorretas (exceto para tipo Sinal)
    const hasInvalidDates =
      props?.dataDetalheProposta?.serie?.serieTabela?.some((item: any) => {
        // Se for tipo Sinal, não validar a data
        if (item.tipoSerie === 100000000 || item.tipoSerie === "100000000") {
          return false;
        }

        try {
          const dataVencimento = parseISO(item.dataVencimento);
          const dia = dataVencimento.getDate();
          return !diasPermitidos.includes(dia);
        } catch (error) {
          return true; // Se não conseguir parsear a data, considerar inválida
        }
      });

    if (hasInvalidDates) {
      toast.error(
        "Existem datas de vencimento incorretas. Apenas os dias 10, 15, 20 ou 25 são permitidos (exceto para o tipo Sinal)."
      );
      return;
    }

    const dataJurosHeader = props?.dataDetalheProposta?.serie?.dataJuros
      ? new Date(props.dataDetalheProposta.serie.dataJuros)
      : null;

    if (dataJurosHeader) {
      const hasJurosOnChaves =
        props?.dataDetalheProposta?.serie?.serieTabela?.some((item: any) => {
          if (!item.juros) return false;
          try {
            const dataVencimento = parseISO(item.dataVencimento);
            return (
              getMonth(dataVencimento) === getMonth(dataJurosHeader) &&
              getYear(dataVencimento) === getYear(dataJurosHeader)
            );
          } catch (error) {
            return false;
          }
        });

      if (hasJurosOnChaves) {
        toast.error(
          "Não é permitido salvar proposta com juros TP em parcela com vencimento na data de chaves. Remova a flag de Juros."
        );
        return;
      }
    }

    setNumeroCotacao("");
    mutate5();
  };

  // Cálculo para número de parcelas baseado na frequência
  const calcularNumeroParcelas = (dateVencimento: any) => {
    const hoje = startOfMonth(new Date());
    const vencimento = startOfMonth(new Date(dateVencimento));

    let totalMeses = differenceInMonths(vencimento, hoje);
    if (vencimento >= hoje) {
      totalMeses += 1;
    }

    const totalParcelas = totalMeses > 0 ? totalMeses : 360;
    return totalParcelas;
  };

  // Função para recalcular quantidade de parcelas baseado na data de vencimento
  const recalcularParcelasPorDataVencimento = (
    dataVencimento: Date,
    frequencia: string,
    tipoSerie: string
  ) => {
    const tipoSerieStr = tipoSerie.toString();
    const frequenciaStr = frequencia.toString();

    // Tipos de série que sempre têm 1 parcela
    const tiposValidosRecalculo = [
      "100000000",
      "100000002",
      "100000003",
      "100000004",
      "100000005",
      "100000012",
    ];

    if (
      tiposValidosRecalculo.includes(tipoSerieStr) ||
      frequenciaStr === "100000005"
    ) {
      return "1";
    }

    // Se não for tipo "Parcelas" (100000001), manter a quantidade atual
    if (tipoSerieStr !== "100000001") {
      return null; // Não altera
    }

    const dataJuros = props?.dataDetalheProposta?.serie?.dataJuros;
    if (!dataJuros) {
      return null;
    }

    // Verificar se a data de vencimento é posterior à data de juros
    const vencimento = startOfMonth(dataVencimento);
    const entrega = startOfMonth(new Date(dataJuros));

    if (vencimento > entrega) {
      // Se a data de vencimento é posterior à data de juros,
      // não recalcular (manter a quantidade atual)
      return null;
    }

    // Se a data de vencimento é anterior ou igual à data de juros,
    // calcular baseado na diferença de meses
    let totalMeses = differenceInMonths(entrega, vencimento);
    if (entrega >= vencimento) {
      totalMeses += 1;
    }

    const numeroParcelas = totalMeses > 0 ? totalMeses : 1;

    // Aplicar a frequência para calcular o número de parcelas
    let parcelas = 0;
    switch (frequenciaStr) {
      case "100000005": // Única
        parcelas = 1;
        break;
      case "100000000": // Mensal
        parcelas = numeroParcelas;
        break;
      case "100000001": // Bimestral
        parcelas = Math.ceil(numeroParcelas / 2);
        break;
      case "100000002": // Trimestral
        parcelas = Math.ceil(numeroParcelas / 3);
        break;
      case "100000003": // Quadrimestral
        parcelas = Math.ceil(numeroParcelas / 4);
        break;
      case "100000004": // Semestral
        parcelas = Math.ceil(numeroParcelas / 6);
        break;
      case "100000006": // Anual
        parcelas = Math.ceil(numeroParcelas / 12);
        break;
      default:
        parcelas = numeroParcelas;
    }

    return parcelas.toString();
  };

  const gerarNumeroParcelas = (
    numeroParcelas: any,
    tipoSerie: string | number,
    frequencia: string | number
  ) => {
    // Normalizar para string
    const tipoSerieStr = tipoSerie.toString();
    const frequenciaStr = frequencia.toString();

    // Ajusta qtdParcelas com base no tipo de série e frequência
    if (tiposValidos.includes(tipoSerieStr) || frequenciaStr === "100000005") {
      return "1";
    }

    if (tipoSerieStr === "100000001") {
      // Parcelas
      const dataConvertida = props?.dataDetalheProposta?.serie?.dataJuros;
      if (dataConvertida) {
        // Esta função não recebe data de vencimento como parâmetro,
        // então não podemos verificar se é posterior à data de juros.
        // Vamos manter a lógica original para este caso específico.
        let parcelas = numeroParcelas;

        switch (frequenciaStr) {
          case "100000005": // Unica
            parcelas = 1;
            break;
          case "100000000": // Mensal
            // mantém o número total de parcelas
            break;
          case "100000001": // Bimestral
            parcelas = Math.ceil(numeroParcelas / 2);
            break;
          case "100000002": // Trimestral
            parcelas = Math.ceil(numeroParcelas / 3);
            break;
          case "100000003": // Quadrimestral
            parcelas = Math.ceil(numeroParcelas / 4);
            break;
          case "100000004": // Semestral
            parcelas = Math.ceil(numeroParcelas / 6);
            break;
          case "100000006": // Anual
            parcelas = Math.ceil(numeroParcelas / 12);
            break;
          default:
            parcelas = numeroParcelas;
        }
        return parcelas.toString();
      }
    }

    return numeroParcelas.toString();
  };

  const calcularFixoDisabled = (row: any): boolean => {
    // Sinal (100000000) sempre tem o fixo marcado como true e não é editável
    return isTipoSinal(row);
  };

  // Carregar opções de tipoSerie com base nas regras de negócio
  useEffect(() => {
    if (editingField === "tipoSerie") {
      // Buscar a lista de tipos de série disponíveis
      const tiposSerieNaTable =
        props?.dataDetalheProposta?.serie?.serieTabela.map((item: any) =>
          item.tipoSerie.toString()
        );

      let tiposFiltrados = tipoSerieArray.filter(
        (item) => !tiposSerieNaTable.includes(item.value)
      );

      const dataAtual = new Date();
      const dataConvertida = props?.dataDetalheProposta?.serie?.dataJuros;

      if (dataConvertida) {
        if (new Date(dataConvertida) < dataAtual) {
          const tiposPermitidos = [
            "100000000",
            "100000002",
            "100000003",
            "100000004",
            "100000005",
            "100000012",
          ];
          tiposFiltrados = tiposFiltrados.filter((item) =>
            tiposPermitidos.includes(item.value)
          );
        }
      }

      const tiposSemprePermitidos = [
        "100000001",
        "100000013",
        "100000014",
        "100000015",
        "100000016",
      ];
      const tiposAdicionais = tipoSerieArray.filter((item) =>
        tiposSemprePermitidos.includes(item.value)
      );

      tiposFiltrados = [
        ...tiposFiltrados,
        ...tiposAdicionais.filter(
          (item) =>
            !tiposFiltrados.some((filtrado) => filtrado.value === item.value)
        ),
      ];

      // Verificações de conflitos entre tipos de série
      const hasAlienacaoFiduciaria = tiposSerieNaTable.includes("100000012");
      const hasFinanciamento = tiposSerieNaTable.includes("100000003");
      const hasCreditoAssociativo = tiposSerieNaTable.includes("100000004");

      // Se tem Alienação Fiduciária, não pode ter Financiamento
      if (hasAlienacaoFiduciaria) {
        tiposFiltrados = tiposFiltrados.filter(
          (item) => item.value !== "100000003"
        );
      }
      // Se tem Financiamento, não pode ter Alienação Fiduciária
      else if (hasFinanciamento) {
        tiposFiltrados = tiposFiltrados.filter(
          (item) => item.value !== "100000012"
        );
      }

      // Se tem Financiamento, não pode ter Crédito Associativo
      if (hasFinanciamento) {
        tiposFiltrados = tiposFiltrados.filter(
          (item) => item.value !== "100000004"
        );
      }
      // Se tem Crédito Associativo, não pode ter Financiamento
      else if (hasCreditoAssociativo) {
        tiposFiltrados = tiposFiltrados.filter(
          (item) => item.value !== "100000003"
        );
      }

      // Adicionar o tipo atual sendo editado à lista
      if (editingRowData) {
        const tipoAtual = editingRowData.tipoSerie.toString();
        if (!tiposFiltrados.some((item) => item.value === tipoAtual)) {
          tiposFiltrados.push({
            value: tipoAtual,
            label: TipoSerieEnum[tipoAtual as keyof typeof TipoSerieEnum],
          });
        }
      }

      setTipoSerieList(tiposFiltrados);
    }
  }, [
    editingField,
    editingRowData,
    props?.dataDetalheProposta?.serie?.serieTabela,
    props?.dataDetalheProposta?.serie?.dataJuros,
  ]);

  useEffect(() => {
    if (props.isRefetching || editItemMutation.isLoading) {
      setIsTableLoading(true);
    } else {
      setIsTableLoading(false);
    }
  }, [props.isRefetching, editItemMutation.isLoading]);

  // Método para salvar a edição
  const saveEdit = (row: any, customDate?: Date | null) => {
    if (!editingRow || !editingField) return;

    // Normalizar tipoSerie e frequencia para string
    const tipoSerie =
      typeof row.tipoSerie === "string"
        ? row.tipoSerie
        : row.tipoSerie.toString();

    let editedFrequencia =
      typeof row.frequencia === "string"
        ? row.frequencia
        : row.frequencia.toString();

    // Ajustar frequência e quantidade de parcelas de acordo com o tipo de série
    let editedQtdParcelas = row.qtdParcelas;

    // Variáveis para edição de tipoSerie
    let editedDataVencimento = row.dataVencimento;
    let editedFixo = row.fixo;
    let newTipoSerie = tipoSerie;

    // Editando o tipo de série
    if (editingField === "tipoSerie") {
      newTipoSerie =
        typeof editValue === "string" ? editValue : editValue.toString();

      // Ajustes específicos baseados no novo tipo de série
      if (newTipoSerie === "100000000") {
        // Sinal
        editedQtdParcelas = "1";
        editedFrequencia = "100000005"; // Única
        editedDataVencimento = new Date().toISOString();
        editedFixo = true;
      } else if (
        [
          "100000002",
          "100000003",
          "100000004",
          "100000005",
          "100000012",
        ].includes(newTipoSerie)
      ) {
        // Outros tipos com configurações específicas
        editedQtdParcelas = "1";
        editedFrequencia = "100000005"; // Única

        // Se for tipo Única (100000002) e tiver data de entrega definida
        if (
          newTipoSerie === "100000002" &&
          props?.dataDetalheProposta?.serie?.dataJuros
        ) {
          const dataEntrega = new Date(
            props.dataDetalheProposta.serie.dataJuros
          );
          dataEntrega.setDate(25);
          editedDataVencimento = dataEntrega.toISOString();
        }

        editedFixo = false;
      }

      // Verificações de conflitos entre tipos de série
      const tiposSerieNaTable =
        props?.dataDetalheProposta?.serie?.serieTabela.map((item: any) =>
          item.tipoSerie.toString()
        );

      // Se for Financiamento (100000003) ou Alienação (100000012), verificar conflitos
      if (newTipoSerie === "100000003" || newTipoSerie === "100000012") {
        if (
          newTipoSerie === "100000003" &&
          tiposSerieNaTable.includes("100000012")
        ) {
          toast.error(
            "Não é possível adicionar Financiamento pois já existe Alienação Fiduciária"
          );
          cancelEditing();
          return;
        }
        if (
          newTipoSerie === "100000012" &&
          tiposSerieNaTable.includes("100000003")
        ) {
          toast.error(
            "Não é possível adicionar Alienação Fiduciária pois já existe Financiamento"
          );
          cancelEditing();
          return;
        }
      }

      // Verificar conflitos entre Financiamento e Crédito Associativo
      if (
        newTipoSerie === "100000003" &&
        tiposSerieNaTable.includes("100000004")
      ) {
        toast.error(
          "Não é possível adicionar Financiamento pois já existe Crédito Associativo"
        );
        cancelEditing();
        return;
      }

      if (
        newTipoSerie === "100000004" &&
        tiposSerieNaTable.includes("100000003")
      ) {
        toast.error(
          "Não é possível adicionar Crédito Associativo pois já existe Financiamento"
        );
        cancelEditing();
        return;
      }
    }
    // Ajustes para quando o tipo de série exige valores específicos
    else if (tiposValidos.includes(tipoSerie)) {
      editedQtdParcelas = 1;
      editedFrequencia = "100000005"; // Unica
    }

    // Se está editando a frequência, ajusta a quantidade de parcelas
    else if (editingField === "frequencia") {
      const newFrequencia =
        typeof editValue === "string" ? editValue : editValue.toString();

      editedFrequencia = newFrequencia;

      if (newFrequencia === "100000005") {
        // Se mudou para Unica
        editedQtdParcelas = 1;
      } else if (tipoSerie === "100000001") {
        // Se é do tipo Parcelas
        const dataEntrega = props?.dataDetalheProposta?.serie?.dataJuros;
        if (dataEntrega) {
          const numeroParcelas = calcularNumeroParcelas(dataEntrega);
          editedQtdParcelas = gerarNumeroParcelas(
            numeroParcelas,
            tipoSerie,
            newFrequencia
          );
        }
      }
    } else if (editingField === "qtdParcelas") {
      editedQtdParcelas = editValue;
    }

    // Preparar os dados para a edição
    const editedData = {
      idUnidade: props.dataDetalheProposta?.idUnidade,
      idSerie: row.idSerie,
      tipoSerie: editingField === "tipoSerie" ? newTipoSerie : tipoSerie,
      qtdParcelas:
        editingField === "qtdParcelas"
          ? typeof editValue === "string"
            ? editValue
            : editValue.toString()
          : typeof editedQtdParcelas === "string"
          ? editedQtdParcelas
          : editedQtdParcelas.toString(),
      frequencia:
        editingField === "frequencia"
          ? typeof editValue === "string"
            ? editValue
            : editValue.toString()
          : editedFrequencia,
      valorParcela:
        editingField === "valorParcela"
          ? editValue
          : formatCurrencyString(row.valorParcela.toString()),
      dtVencimento:
        editingField === "dataVencimento"
          ? customDate || editingDate
          : editingField === "tipoSerie"
          ? editedDataVencimento
          : row.dataVencimento,
      juros: row.juros,
      fixo: editingField === "tipoSerie" ? editedFixo : row.fixo,
      idLeadCorretor: params.idLeadCorretor,
      idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
    };

    // Atualizar o estado do juros automaticamente baseado na data de vencimento (igual ao AdicionarItemModal)
    if (editingField === "dataVencimento") {
      const dataJuros = new Date(props?.dataDetalheProposta?.serie?.dataJuros);
      if (dataJuros && dataJuros > new Date()) {
        const dateToValidate = customDate || editingDate;
        if (startOfMonth(dateToValidate as Date) > startOfMonth(dataJuros)) {
          // Se a data de vencimento for após a data de juros, ativar juros
          editedData.juros = true;
        } else {
          // Se a data de vencimento for antes da data de juros, desativar juros
          editedData.juros = false;
        }
      }
    }

    // Para juros e fixo, salva diretamente sem validações adicionais
    if (editingField === "juros" || editingField === "fixo") {
      setEditingRowData(editedData);
      editItemMutation.mutate();
      return;
    }

    // Validações para outros campos
    if (editingField === "dataVencimento") {
      const dateToValidate = customDate || editingDate;

      // Tipos com data de vencimento fixa não têm restrição de dias para vencimento
      if (
        !validarDiaPermitido(dateToValidate as Date) &&
        !isTipoDataVencimentoFixa(row)
      ) {
        toast.error(
          "Apenas os dias 10, 15, 20 ou 25 são permitidos para vencimento"
        );
        cancelEditing();
        return;
      }

      // Verificar se a data selecionada é anterior à data do Sinal
      // Apenas para séries diferentes de Sinal ou Unica
      const sinalRow = rows.find((r) => isTipoSinal(r));

      if (sinalRow && !isTipoDataVencimentoFixa(row)) {
        const minimunDate = parseISO(sinalRow.dataVencimento);
        if (isBefore(dateToValidate as Date, minimunDate)) {
          toast.error(
            "A data de vencimento não pode ser anterior à data do Sinal"
          );
          cancelEditing();
          return;
        }
      }

      const dataJuros = new Date(props?.dataDetalheProposta?.serie?.dataJuros);
      if (row.juros === true && (dateToValidate as Date) < dataJuros) {
        toast.error(
          "Séries anteriores ou iguais à data de juros não podem ter TP. Retire a flag da opção juros nestes casos."
        );
        cancelEditing();
        return;
      }

      if (
        dataJuros &&
        getMonth(dataJuros) === getMonth(dateToValidate as Date) &&
        getYear(dataJuros) === getYear(dateToValidate as Date) &&
        row.juros
      ) {
        toast.error(
          "Mês e ano do vencimento igual a data de chaves, nesse caso remova a flag de Juros"
        );
        cancelEditing();
        return;
      }

      // Para séries do tipo "Parcelas", verificar se a quantidade atual ainda é válida na nova lista
      if (row.tipoSerie.toString() === "100000001") {
        const dataJurosRecalculo = props?.dataDetalheProposta?.serie?.dataJuros;
        if (dataJurosRecalculo) {
          const vencimento = startOfMonth(dateToValidate as Date);
          const entrega = startOfMonth(new Date(dataJurosRecalculo));

          // Verificar se a data de vencimento é posterior à data de juros
          if (vencimento > entrega) {
            // Se a data de vencimento é posterior à data de juros,
            // não há restrição na quantidade de parcelas
            editedQtdParcelas = row.qtdParcelas.toString();
            editedData.qtdParcelas = row.qtdParcelas.toString();
          } else {
            // Se a data de vencimento é anterior ou igual à data de juros,
            // calcular baseado na diferença de meses
            let totalMeses = differenceInMonths(entrega, vencimento);
            if (entrega >= vencimento) {
              totalMeses += 1;
            }

            const numeroParcelas = totalMeses > 0 ? totalMeses : 1;
            let maxParcelas = numeroParcelas;

            const frequenciaStr = row.frequencia.toString();
            switch (frequenciaStr) {
              case "100000000": // Mensal
                maxParcelas = numeroParcelas;
                break;
              case "100000001": // Bimestral
                maxParcelas = Math.ceil(numeroParcelas / 2);
                break;
              case "100000002": // Trimestral
                maxParcelas = Math.ceil(numeroParcelas / 3);
                break;
              case "100000003": // Quadrimestral
                maxParcelas = Math.ceil(numeroParcelas / 4);
                break;
              case "100000004": // Semestral
                maxParcelas = Math.ceil(numeroParcelas / 6);
                break;
              case "100000006": // Anual
                maxParcelas = Math.ceil(numeroParcelas / 12);
                break;
              default:
                maxParcelas = numeroParcelas;
            }

            // Verificar se a quantidade atual ainda é válida (está dentro do limite)
            const qtdAtual = parseInt(row.qtdParcelas.toString(), 10);
            if (qtdAtual > maxParcelas) {
              // Se a quantidade atual excede o novo limite, usar o valor máximo do recálculo
              editedQtdParcelas = maxParcelas.toString();
              editedData.qtdParcelas = maxParcelas.toString();
            } else {
              // Se a quantidade atual ainda é válida, manter
              editedQtdParcelas = row.qtdParcelas.toString();
              editedData.qtdParcelas = row.qtdParcelas.toString();
            }
          }
        }
      }
    }

    // Atualizar o estado e fazer a mutação
    setEditingRowData(editedData);
    editItemMutation.mutate();
  };

  // Funções para manipular checkbox
  const handleJurosChange = (row: any) => {
    // Verificar condições especiais para edição de juros
    const dataJuros = props?.dataDetalheProposta?.serie?.dataJuros
      ? new Date(props.dataDetalheProposta.serie.dataJuros)
      : null;

    const tipoSerie =
      typeof row.tipoSerie === "string"
        ? row.tipoSerie
        : row.tipoSerie.toString();

    // Se está TENTANDO DESMARCAR o juros (row.juros === true, vai virar false)
    if (row.juros) {
      // Verificar se série com vencimento após data de juros está tentando desmarcar juros
      if (dataJuros && parseISO(row.dataVencimento) > dataJuros) {
        toast.error("Parcelas após a entrega das chaves devem incluir juros");
      }
    }

    // Se está TENTANDO MARCAR o juros (!row.juros, vai virar true)
    if (!row.juros) {
      if (dataJuros && parseISO(row.dataVencimento) < dataJuros) {
        toast.error(
          "Séries anteriores ou iguais à data de juros não podem ter TP. Retire a flag da opção juros nestes casos."
        );
        return;
      }

      if (
        dataJuros &&
        getMonth(parseISO(row.dataVencimento)) === getMonth(dataJuros) &&
        getYear(parseISO(row.dataVencimento)) === getYear(dataJuros)
      ) {
        toast.error(
          "Mês e ano do vencimento igual a data de chaves, nesse caso remova a flag de Juros"
        );
        return;
      }
    }

    // Aplicar a edição diretamente
    setEditingRow(row.idSerie);
    setEditingField("juros");
    setEditingRowData({
      idUnidade: props.dataDetalheProposta?.idUnidade,
      idSerie: row.idSerie,
      tipoSerie:
        typeof row.tipoSerie === "string"
          ? row.tipoSerie
          : row.tipoSerie.toString(),
      qtdParcelas:
        typeof row.qtdParcelas === "string"
          ? row.qtdParcelas
          : row.qtdParcelas.toString(),
      frequencia:
        typeof row.frequencia === "string"
          ? row.frequencia
          : row.frequencia.toString(),
      valorParcela: formatCurrencyString(row.valorParcela.toString()),
      dtVencimento: row.dataVencimento,
      juros: !row.juros,
      fixo: row.fixo,
      idLeadCorretor: params.idLeadCorretor,
      idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
    });

    // Chamar a API
    editItemMutation.mutate();
  };

  const handleFixoChange = (row: any) => {
    // Verificar se o tipo é Sinal
    if (isTipoSinal(row)) {
      return; // Não permitir alteração para tipo Sinal
    }

    // Aplicar a edição diretamente
    setEditingRow(row.idSerie);
    setEditingField("fixo");
    setEditingRowData({
      idUnidade: props.dataDetalheProposta?.idUnidade,
      idSerie: row.idSerie,
      tipoSerie:
        typeof row.tipoSerie === "string"
          ? row.tipoSerie
          : row.tipoSerie.toString(),
      qtdParcelas:
        typeof row.qtdParcelas === "string"
          ? row.qtdParcelas
          : row.qtdParcelas.toString(),
      frequencia:
        typeof row.frequencia === "string"
          ? row.frequencia
          : row.frequencia.toString(),
      valorParcela: formatCurrencyString(row.valorParcela.toString()),
      dtVencimento: row.dataVencimento,
      juros: row.juros,
      fixo: !row.fixo,
      idLeadCorretor: params.idLeadCorretor,
      idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
    });

    // Chamar a API
    editItemMutation.mutate();
  };

  return (
    <>
      <Styles.GlobalStyles />
      <Styles.Container>
        <Styles.Column flex={1}>
          <Styles.LightText>Empreendimento</Styles.LightText>
          <Styles.StrongText>
            {props?.dataDetalheProposta?.nomeEmpreendimento}
          </Styles.StrongText>
        </Styles.Column>
        <Styles.Column flex={0.4}>
          <Styles.LightText>Bloco</Styles.LightText>
          <Styles.StrongText>
            {props?.dataDetalheProposta?.nomeBloco}
          </Styles.StrongText>
        </Styles.Column>
        <Styles.Column flex={0.4}>
          <Styles.LightText>Unidade</Styles.LightText>
          <Styles.StrongText>
            {props?.dataDetalheProposta?.nomeUnidade}
          </Styles.StrongText>
        </Styles.Column>
        {isGerenteComercial && (
          <>
            <Styles.Column flex={0.4}>
              <Styles.LightText>R$ VP T0</Styles.LightText>
              <Styles.StrongText>
                R$  
                {props?.dataDetalheProposta?.valorNominalT0?.toLocaleString(
                  "pt-br",
                  {
                    minimumFractionDigits: 2,
                  }
                ) || "-"}
              </Styles.StrongText>
            </Styles.Column>
            <Styles.Column flex={0.4}>
              <Styles.LightText>% VP T0</Styles.LightText>
              <Styles.StrongText>
                {props?.dataDetalheProposta?.percentualVpT0?.toLocaleString(
                  "pt-br",
                  {
                    minimumFractionDigits: 2,
                  }
                ) || "-"}
              </Styles.StrongText>
            </Styles.Column>
          </>
        )}
        <Styles.Column flex={0.4}>
          <Styles.LightText>Valor de tabela</Styles.LightText>
          <Styles.StrongText>
            R$  
            {props?.dataDetalheProposta?.valorNominalT1.toLocaleString(
              "pt-br",
              {
                minimumFractionDigits: 2,
              }
            )}
          </Styles.StrongText>
        </Styles.Column>
      </Styles.Container>
      <Styles.SecondContainer>
        <Styles.Row>
          <Styles.StrongText> Fluxo de pagamento</Styles.StrongText>
          <button
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
            }}
            onClick={() => setOcultar(!ocultar)}
            type="button"
          >
            {ocultar === false ? (
              <IoEyeSharp size={25} color="#505050" />
            ) : (
              <BsFillEyeSlashFill size={25} color="#505050" />
            )}
          </button>
        </Styles.Row>
        <Styles.HorizontalLine />
        <Styles.Row>
          <Styles.Column flex={0.8}>
            <Styles.LightText>Valor da venda</Styles.LightText>

            <Styles.StrongText>
              R$  
              {props?.dataDetalheProposta?.valorVenda.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
              })}
            </Styles.StrongText>
          </Styles.Column>
          <Styles.Column flex={0.8}>
            <Styles.LightText>Valor R$ / m²</Styles.LightText>

            <Styles.StrongText>
              R$  
              {props?.dataDetalheProposta?.valorMetro.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
              })}
            </Styles.StrongText>
          </Styles.Column>
          <Styles.Column flex={0.8}>
            <Styles.LightText>Valor VP</Styles.LightText>

            <Styles.StrongText>
              R$  
              {props?.dataDetalheProposta?.valorVp.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
              })}
            </Styles.StrongText>
          </Styles.Column>
          <Styles.Column flex={0.8}>
            <Styles.LightText>(-) ∆ R$ VP T1</Styles.LightText>

            <Styles.StrongText>
              R$  
              {props?.dataDetalheProposta?.delta.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
              })}
            </Styles.StrongText>
          </Styles.Column>
          <Styles.Column flex={0.8}>
            <Styles.LightText>(-) ∆ % VP T1</Styles.LightText>
            <Styles.StrongText>
              {props?.dataDetalheProposta?.deltaPorcentagem.toFixed(2)}
            </Styles.StrongText>
          </Styles.Column>
          <Styles.Column flex={0.5}>
            <Styles.LightText>% VP Comercial</Styles.LightText>
            <Styles.StrongText>
              {props?.dataDetalheProposta?.percentualVpComercial}
            </Styles.StrongText>
          </Styles.Column>
        </Styles.Row>
        <Styles.Row>
          <Styles.ObervationContainer>
            {ocultar ? (
              <Styles.ObservationOculta>
                {props?.dataDetalheProposta?.observacaoSimulacao
                  ? props.dataDetalheProposta.observacaoSimulacao
                  : "Sem informação"}
              </Styles.ObservationOculta>
            ) : (
              <Styles.TextBlue>
                {props?.dataDetalheProposta?.observacaoSimulacao
                  ? props.dataDetalheProposta.observacaoSimulacao
                  : "Sem informação"}
              </Styles.TextBlue>
            )}
          </Styles.ObervationContainer>
        </Styles.Row>
      </Styles.SecondContainer>
      <Styles.ContentTable>
        <div
          style={{
            padding: "0px 16px 0px 16px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "16px",
            }}
          >
            <div>
              <Styles.EditabilityHint style={{ marginBottom: "8px" }}>
                <span style={{ marginRight: "5px", fontWeight: "bold" }}>
                  ATENÇÃO:
                </span>
                Troca de vencimento de parcelas pré chaves, podem sofrer
                alterações na quantidade de parcelas disponíveis para seleção;
              </Styles.EditabilityHint>
              <Styles.EditabilityHint>
                Clique nos campos para editar diretamente na tabela
              </Styles.EditabilityHint>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <Styles.DataJurosText>Data Juros:</Styles.DataJurosText>
              <Styles.DataJurosInfo>
                {formatarDataISO(props?.dataDetalheProposta?.serie?.dataJuros)}
              </Styles.DataJurosInfo>
              <Styles.DataJurosText>Taxa Juros:</Styles.DataJurosText>
              <Styles.DataJurosInfo>
                {props?.dataDetalheProposta?.serie?.taxaJuros}%
              </Styles.DataJurosInfo>
            </div>
          </div>
          <TableContainer
            sx={{
              borderRadius: 2,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              boxShadow: "none",
              border: 1,
              borderColor: "#E0E0E0",
              marginTop: 2,
              position: "relative",
              opacity: isTableLoading ? 0.5 : 1,
              pointerEvents: isTableLoading ? "none" : "auto",
            }}
            component={Paper}
          >
            {isTableLoading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                  borderRadius: "8px",
                }}
              >
                <MaterialUI.CircularProgress size={40} />
              </div>
            )}
            <Table aria-label="simple table">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#F2F4F8" }}>
                  <TableCell sx={{ minWidth: 15, padding: "2px 4px" }} />
                  <TableCell sx={{ minWidth: 100, padding: "2px 4px" }}>
                    <Styles.LightText>Tipo Série</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 60, padding: "2px 4px" }}>
                    <Styles.LightText>Qtd. P.</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 70, padding: "2px 4px" }}>
                    <Styles.LightText>Freq.</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 60, padding: "2px 4px" }}>
                    <Styles.LightText>% Valor</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120, padding: "2px 4px" }}>
                    <Styles.LightText>Valor Parcela</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120, padding: "2px 4px" }}>
                    <Styles.LightText>Valor C/TP</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120, padding: "2px 4px" }}>
                    <Styles.LightText>Valor VP</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 100, padding: "2px 4px" }}>
                    <Styles.LightText>Vencimento</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 15, padding: "2px 4px" }}>
                    <Styles.LightText>Juros</Styles.LightText>
                  </TableCell>
                  <TableCell sx={{ minWidth: 15, padding: "2px 4px" }}>
                    <Styles.LightText>Fixo</Styles.LightText>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.idSerie}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      height: "30px",
                    }}
                  >
                    <TableCell sx={{ minWidth: 15, padding: "8px 4px" }}>
                      <CheckBox
                        disabled={!props?.dataDetalheProposta?.editavel}
                        checked={selectedRows.some(
                          (item: any) => item.idSerie === row.idSerie
                        )}
                        onChange={() => handleSelectRow(row)}
                      />
                    </TableCell>
                    <TableCell sx={{ minWidth: 100, padding: "8px 4px" }}>
                      {editingRow === row.idSerie &&
                      editingField === "tipoSerie" ? (
                        <Select
                          size="small"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          onBlur={() => saveEdit(row)}
                          autoFocus
                          fullWidth
                          style={{ height: 30 }}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#2d5bff",
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                overflow: "auto",
                              },
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                          }}
                        >
                          {tipoSerieList.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        <Tooltip
                          title={
                            isEditable()
                              ? "Clique para editar o tipo de série"
                              : ""
                          }
                          arrow
                        >
                          <Styles.EditableField
                            onClick={() =>
                              isEditable() &&
                              startEditing(
                                row.idSerie,
                                "tipoSerie",
                                row.tipoSerie,
                                row
                              )
                            }
                            aria-label={`Editar tipo de série: ${
                              TipoSerieEnum[
                                row.tipoSerie.toString() as keyof typeof TipoSerieEnum
                              ]
                            }`}
                            style={{
                              cursor: isEditable() ? "pointer" : "default",
                            }}
                          >
                            {
                              TipoSerieEnum[
                                row.tipoSerie.toString() as keyof typeof TipoSerieEnum
                              ]
                            }
                          </Styles.EditableField>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ minWidth: 60, padding: "8px 4px" }}>
                      {editingRow === row.idSerie &&
                      editingField === "qtdParcelas" ? (
                        <Select
                          size="small"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          onBlur={() => saveEdit(row)}
                          autoFocus
                          fullWidth
                          disabled={
                            tiposValidos.includes(row.tipoSerie.toString()) ||
                            row.frequencia.toString() === "100000005"
                          }
                          style={{ height: 30 }}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#2d5bff",
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                overflow: "auto",
                              },
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                          }}
                        >
                          {qtdsParcelasList.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        <Tooltip
                          title={
                            isEditable() &&
                            !(
                              tiposValidos.includes(row.tipoSerie.toString()) ||
                              row.frequencia.toString() === "100000005"
                            )
                              ? "Clique para editar a quantidade de parcelas"
                              : tiposValidos.includes(
                                  row.tipoSerie.toString()
                                ) || row.frequencia.toString() === "100000005"
                              ? "Quantidade fixa para este tipo de série"
                              : ""
                          }
                          arrow
                        >
                          <Styles.EditableField
                            onClick={() =>
                              isEditable() &&
                              !tiposValidos.includes(
                                row.tipoSerie.toString()
                              ) &&
                              row.frequencia.toString() !== "100000005" &&
                              startEditing(
                                row.idSerie,
                                "qtdParcelas",
                                row.qtdParcelas,
                                row
                              )
                            }
                            aria-label={`Editar quantidade de parcelas: ${row.qtdParcelas}`}
                            style={{
                              cursor:
                                isEditable() &&
                                !(
                                  tiposValidos.includes(
                                    row.tipoSerie.toString()
                                  ) || row.frequencia.toString() === "100000005"
                                )
                                  ? "pointer"
                                  : "default",
                            }}
                          >
                            {row.qtdParcelas}
                          </Styles.EditableField>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ minWidth: 70, padding: "8px 4px" }}>
                      {editingRow === row.idSerie &&
                      editingField === "frequencia" ? (
                        <Select
                          size="small"
                          value={editValue || row.frequencia.toString()}
                          onChange={(e) => setEditValue(e.target.value)}
                          onBlur={() => saveEdit(row)}
                          autoFocus
                          fullWidth
                          disabled={tiposValidos.includes(
                            row.tipoSerie.toString()
                          )}
                          style={{ height: 30 }}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#2d5bff",
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                overflow: "auto",
                              },
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                          }}
                        >
                          {Object.entries(FrequenciaEnum).map(
                            ([value, label]) => (
                              <MenuItem key={value} value={value}>
                                {label}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      ) : (
                        <Tooltip
                          title={
                            isEditable() &&
                            !tiposValidos.includes(row.tipoSerie.toString())
                              ? "Clique para editar a frequência"
                              : ""
                          }
                          arrow
                        >
                          <Styles.EditableField
                            onClick={() =>
                              isEditable() &&
                              !tiposValidos.includes(
                                row.tipoSerie.toString()
                              ) &&
                              startEditing(
                                row.idSerie,
                                "frequencia",
                                row.frequencia,
                                row
                              )
                            }
                            aria-label={`Editar frequência: ${
                              FrequenciaEnum[
                                row.frequencia.toString() as keyof typeof FrequenciaEnum
                              ]
                            }`}
                            style={{
                              cursor:
                                isEditable() &&
                                !tiposValidos.includes(row.tipoSerie.toString())
                                  ? "pointer"
                                  : "default",
                            }}
                          >
                            {
                              FrequenciaEnum[
                                row.frequencia.toString() as keyof typeof FrequenciaEnum
                              ]
                            }
                          </Styles.EditableField>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ minWidth: 60, padding: "8px 4px" }}>
                      <p>{row.valorPercent}</p>
                    </TableCell>
                    <TableCell sx={{ minWidth: 120, padding: "8px 4px" }}>
                      {editingRow === row.idSerie &&
                      editingField === "valorParcela" ? (
                        <TextField
                          size="small"
                          value={editValue}
                          onChange={handleValorParcelaChange}
                          onBlur={() => saveEdit(row)}
                          autoFocus
                          fullWidth
                          InputProps={{
                            style: { height: 30, width: 150 },
                            className: "highlighted-input",
                            startAdornment: (
                              <InputAdornment position="start">
                                R$
                              </InputAdornment>
                            ),
                          }}
                        />
                      ) : (
                        <Tooltip
                          title={
                            isEditable()
                              ? "Clique para editar o valor da parcela"
                              : ""
                          }
                          arrow
                        >
                          <Styles.EditableField
                            onClick={() =>
                              isEditable() &&
                              startEditing(
                                row.idSerie,
                                "valorParcela",
                                row.valorParcela,
                                row
                              )
                            }
                            aria-label={`Editar valor da parcela: R$ ${parseFloat(
                              row?.valorParcela
                            ).toLocaleString("pt-BR", {
                              minimumFractionDigits: 2,
                            })}`}
                            style={{
                              cursor: isEditable() ? "pointer" : "default",
                            }}
                          >
                            {`R$ ${parseFloat(row?.valorParcela).toLocaleString(
                              "pt-BR",
                              {
                                minimumFractionDigits: 2,
                              }
                            )}`}
                          </Styles.EditableField>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ minWidth: 120, padding: "8px 4px" }}>
                      <p>
                        {`R$ ${parseFloat(row?.valorTP).toLocaleString(
                          "pt-BR",
                          {
                            minimumFractionDigits: 2,
                          }
                        )}`}
                      </p>
                    </TableCell>
                    <TableCell sx={{ minWidth: 120, padding: "8px 4px" }}>
                      <p>
                        {`R$ ${parseFloat(row?.valorVp).toLocaleString(
                          "pt-BR",
                          {
                            minimumFractionDigits: 2,
                          }
                        )}`}
                      </p>
                    </TableCell>
                    <TableCell sx={{ minWidth: 100, padding: "8px 4px" }}>
                      {editingRow === row.idSerie &&
                      editingField === "dataVencimento" ? (
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          locale={ptBR}
                        >
                          <DatePicker
                            inputFormat="dd/MM/yyyy"
                            value={editingDate}
                            onChange={(newValue) => {
                              setEditingDate(newValue);
                            }}
                            onAccept={(newValue) => saveEdit(row, newValue)}
                            onClose={() => cancelEditing()}
                            open={
                              editingRow === row.idSerie &&
                              editingField === "dataVencimento"
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                fullWidth
                                autoFocus
                                InputProps={{
                                  ...params.InputProps,
                                  style: { height: 30, width: 150 },
                                  className: "highlighted-input",
                                }}
                              />
                            )}
                            shouldDisableDate={(date) => {
                              if (isTipoDataVencimentoFixa(row)) return false;
                              return !diasPermitidos.includes(date.getDate());
                            }}
                          />
                        </LocalizationProvider>
                      ) : (
                        <Tooltip
                          title={
                            isEditable() && !isTipoDataVencimentoFixa(row)
                              ? "Clique para editar a data de vencimento"
                              : isTipoDataVencimentoFixa(row)
                              ? `Data de vencimento fixa para o tipo ${
                                  row.tipoSerie.toString() === "100000000"
                                    ? "Sinal"
                                    : "Unica"
                                }`
                              : ""
                          }
                          arrow
                        >
                          <Styles.EditableField
                            onClick={() =>
                              isEditable() &&
                              !isTipoDataVencimentoFixa(row) &&
                              startEditing(
                                row.idSerie,
                                "dataVencimento",
                                row.dataVencimento,
                                row
                              )
                            }
                            aria-label={`Editar data de vencimento: ${formatarDataISO(
                              row.dataVencimento
                            )}`}
                            style={{
                              cursor:
                                isEditable() && !isTipoDataVencimentoFixa(row)
                                  ? "pointer"
                                  : "default",
                            }}
                            lineColor={(() => {
                              // Se for tipo Sinal, sempre azul
                              if (isTipoSinal(row)) {
                                return "#2d5bff";
                              }
                              // Se for tipo com data fixa, sempre azul
                              if (isTipoDataVencimentoFixa(row)) {
                                return "#2d5bff";
                              }
                              // Para outros tipos, verificar se o dia está nos permitidos
                              try {
                                const dataVencimento = parseISO(
                                  row.dataVencimento
                                );
                                const dia = dataVencimento.getDate();
                                return diasPermitidos.includes(dia)
                                  ? "#2d5bff"
                                  : "#d32f2f";
                              } catch (error) {
                                return "#2d5bff"; // Em caso de erro, manter azul
                              }
                            })()}
                          >
                            {formatarDataISO(row.dataVencimento)}
                          </Styles.EditableField>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ minWidth: 15, padding: "8px 4px" }}>
                      <Tooltip
                        title={
                          isEditable()
                            ? row.juros
                              ? "Desativar juros"
                              : "Ativar juros"
                            : ""
                        }
                        arrow
                      >
                        <div>
                          <CheckBox
                            checked={row.juros}
                            onChange={() =>
                              isEditable() && handleJurosChange(row)
                            }
                            disabled={!isEditable()}
                          />
                        </div>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ minWidth: 15, padding: "8px 4px" }}>
                      <Tooltip
                        title={
                          isEditable() && !calcularFixoDisabled(row)
                            ? row.fixo
                              ? "Desativar fixo"
                              : "Ativar fixo"
                            : ""
                        }
                        arrow
                      >
                        <div>
                          <CheckBox
                            checked={row.fixo}
                            disabled={
                              calcularFixoDisabled(row) || !isEditable()
                            }
                            onChange={() =>
                              isEditable() && handleFixoChange(row)
                            }
                          />
                        </div>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Styles.ContentTable>

      <Styles.ContainerFooter>
        <Styles.Button
          disabled={disableButton() || !props?.dataDetalheProposta?.editavel}
          onClick={openDescontoModal}
        >
          <Styles.LightTextBlue>Desconto</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.Button
          disabled={disableButton() || !props?.dataDetalheProposta?.editavel}
          onClick={openZerarPVModal}
        >
          <Styles.LightTextBlue>Zerar PV</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.Button
          onClick={handleOpen}
          disabled={!props?.dataDetalheProposta?.editavel}
        >
          <Styles.LightTextBlue>Voltar Fluxo Original</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.MinButton
          disabled={
            disableButtonDelete() || !props?.dataDetalheProposta?.editavel
          }
          onClick={openExcluirModal}
        >
          <BiSolidTrashAlt style={{ color: "#2d5bff" }} size={20} />
        </Styles.MinButton>
        <Styles.MinButton
          onClick={openAddItemModal}
          disabled={!props?.dataDetalheProposta?.editavel}
        >
          <RiAddLine style={{ color: "#2d5bff" }} size={20} />
        </Styles.MinButton>
      </Styles.ContainerFooter>
      <Styles.SecondContainerFooter>
        <Styles.Button onClick={openVoltarFLuxoModal}>
          <Styles.LightTextBlue>Voltar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          onClick={() => {
            handleNovaOportunidade();
          }}
          disabled={!props?.dataDetalheProposta?.editavel}
        >
          {isLoading5 ? (
            <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            <Styles.LightTextWhite>Concluir</Styles.LightTextWhite>
          )}
        </Styles.ButtonBlue>
      </Styles.SecondContainerFooter>

      <ModalCommon
        open={isExcluirModalOpen}
        setOpenModal={setIsExcluirModalOpen}
        onClose={() => {
          closeExcluirModal();
        }}
      >
        <ExcluirModal
          onClose={closeExcluirModal}
          mutate={mutate4}
          reset4={reset4}
          isLoading={isLoading4}
          isSuccess={isSuccess4}
          refetch={props.refetchProposta}
        />
      </ModalCommon>
      <ModalCommon
        open={isDescontoModalOpen}
        setOpenModal={setIsDescontoModalOpen}
        onClose={closeDescontoModal}
      >
        <DescontoModal
          onClose={closeDescontoModal}
          desconto={desconto}
          setDesconto={setDesconto}
          mutate={mutate3}
          reset3={reset3}
          isLoading={isLoading3}
          isSuccess={isSuccess3}
          refetch={props.refetchProposta}
        />
      </ModalCommon>
      <ModalCommon
        open={openModal}
        setOpenModal={() => {}}
        onClose={handleClose}
      >
        <ResetarFluxoModal
          onClose={handleClose}
          mutate={mutate1}
          refetch={props.refetchProposta}
          reset1={reset1}
          isLoading={isLoading1}
          isSuccess={isSuccess1}
        />
      </ModalCommon>
      <ModalCommon
        open={isZerarPVModalOpen}
        setOpenModal={() => {}}
        onClose={closeZerarPVModal}
      >
        <ZerarPVModal
          onClose={closeZerarPVModal}
          mutate={mutate2}
          isLoading={isLoading2}
          isSuccess={isSuccess2}
          refetch={props.refetchProposta}
          reset2={reset2}
        />
      </ModalCommon>
      <ModalCommon
        open={isAddItemModalOpen}
        setOpenModal={() => {}}
        onClose={closeAddItemModal}
      >
        <AdicionarItemModal
          onClose={closeAddItemModal}
          tableData={props.dataDetalheProposta}
          refetch={props.refetchProposta}
          dataDetalheOportunidade={props.dataDetalheOportunidade}
        />
      </ModalCommon>
      <ModalCommon
        open={isEditItemModalOpen}
        setOpenModal={() => {}}
        onClose={closeEditItemModal}
      >
        <EditarItemModal
          onClose={closeEditItemModal}
          tableData={props.dataDetalheProposta}
          refetch={() => {
            props.refetchProposta();
            setSelectedRows([]);
          }}
          dataDetalheOportunidade={props.dataDetalheOportunidade}
          selectedRow={selectedRows[0]}
        />
      </ModalCommon>
      {/* <ModalCommon
        open={isNovaOportunidadeModalOpen}
        setOpenModal={() => {}}
        onClose={closeNovaOportunidadeModal}
      >
        <NovaOportunidadeModal
          onClose={closeNovaOportunidadeModal}
          headerData={props.data}
          unidadeDataReal={props.unidadeDataReal}
          numeroCotacao={numeroCotacao}
          idLead={props.idLead}
          refetch={props.refetchProposta}
        />
      </ModalCommon> */}
      <ModalCommon
        open={isVoltarFluxoModalOpen}
        setOpenModal={() => {}}
        onClose={closeVoltarFluxoModal}
      >
        <VoltarFluxoModal
          onClose={closeVoltarFluxoModal}
          onCloseProposta={props.onClose}
        />
      </ModalCommon>
    </>
  );
};

export default ProductCard;
